import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(sessionStorage.getItem('darkMode') === 'true');
    const [loading] = useState(false);

    const applyCurrentTheme = useCallback((isDark) => {
        if (isDark) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
    }, []);

    const toggleDarkMode = useCallback(() => {
        const newDarkMode = !darkMode;
        setDarkMode(newDarkMode);
        sessionStorage.setItem('darkMode', String(newDarkMode));
        applyCurrentTheme(newDarkMode);
    }, [darkMode, applyCurrentTheme]);

    useEffect(() => {
        // Carga inicial
        applyCurrentTheme(darkMode);
    }, [darkMode, applyCurrentTheme]);

    const value = React.useMemo(() => ({
        institutionalTheme: { isDark: darkMode }, // Reduced representation for backward compatibility
        darkMode,
        toggleDarkMode,
        refreshTheme: () => {}, // No longer fetches from backend
        loading
    }), [darkMode, toggleDarkMode, loading]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
